type StorageServiceType = "session" | "local";

export const storageService = (type: StorageServiceType = "session") => {
  const storage = type === "session" ? sessionStorage : localStorage;

  const putInStorage = (key: string, value: string) =>
    storage.setItem(key, value);
  const removeFromStorage = (key: string) => storage.removeItem(key);

  const getFromStorage = (key: string) => storage.getItem(key);

  const getBoolFromStorage = (key: string): boolean => {
    const item = getFromStorage(key);
    if (!item) return false;
    return item !== "false";
  };

  const removeGroupFromStorage = (group: string) => {
    const sessionKeys = Object.keys(storage).filter((key) =>
      key.startsWith(group)
    );

    sessionKeys.forEach((key) => {
      removeFromStorage(key);
    });
  };

  return {
    putInStorage,
    removeFromStorage,
    getFromStorage,
    getBoolFromStorage,
    removeGroupFromStorage
  };
};
